import { Link,useLocation } from "react-router-dom";
import React, { useEffect, useRef, useState } from "react";
import API from '../Services/Auth'

const Navbar = ({ children }) => {
    const location = useLocation();
  const isFetched = useRef(false);
  const [currentPassword, setCurrentPassword] = useState("")
  const [newPassword, setNewPassword] = useState("")
  const [permissions, setPermissions] = useState({})

  useEffect(() => {
    getPermissionData()
    const token = localStorage.getItem("token");
    //const aa = localStorage.getItem("company_id")
    //console.log("token1111", token);
    if (!token || token.trim() === "") {
      window.location.replace("/Login");
      return;
    }


    if (!isFetched.current) {
      isFetched.current = true;
      // console.log("Fetching initial data...");
    }
  }, []);


  const logout = async () => {
    localStorage.clear();
    sessionStorage.clear();
    window.location.replace("/Login");

  };

  const resetPasswordData = async () => {
    try {
      const userId = localStorage.getItem("loginId");
      if (!userId) {
        alert("User ID not found in localStorage");
        window.location.replace("/Login");
        return;
      }
      if (!currentPassword || !newPassword) {
        alert("Current password or new password is missing");
        return;
      }
      const payload = {
        currentPassword: currentPassword,
        password: newPassword,
        user_id: userId
      };
      const response = await API.resetPassword(payload);
      if (response?.status === 200) {
        // toast.success("Password reset successful!");
        alert("Password reset successful!")
        // console.log("Password reset successful:", response.data);
      } else {
        //toast.error("Password reset failed. Please try again.");
        alert("Password reset failed. Please try again.");
        console.error("Password reset failed:", response);
      }
    } catch (error) {
      if (error.response) {
        alert(`Error: ${error.response.data?.message || "Something went wrong!"}`);
        console.error("API error:", error.response.data);
      } else if (error.request) {
        alert("No response from server. Please check your connection.");
        console.error("No response from server:", error.request);
      } else {
        alert("An unexpected error occurred.");
        console.error("Error:", error.message);
      }
    }
  };

  const getPermissionData = async () => {
    try {
      const response = await API.getPermession({});
     // console.log("Permission data:", response?.data?.data);
      delete response?.data?.data["POS Portal"]
      setPermissions(response?.data?.data || {});
    } catch (error) {
      console.error("Error fetching permissions:", error);
    }
  };

  return (

    <div className="container-scroller">
  <nav className="navbar default-layout-navbar col-lg-12 col-12 p-0 fixed-top d-flex flex-row">
    <div className="text-center navbar-brand-wrapper d-flex align-items-center justify-content-start">
      <Link className="navbar-brand brand-logo" to="/Dashboard">
        <img
          src="https://files.ypaycard.com/SkyJumper/Logo.png"
          alt="logo"
          style={{
            height: "65px",
            width: "90px",
            marginTop: "10px",
            textAlign: "center",
          }}
          className="image-rounded text-center"
        />
      </Link>
      <Link className="navbar-brand brand-logo-mini" to="/Dashboard">
        <img
          src="https://files.ypaycard.com/SkyJumper/Logo.png"
          alt="logo"
          style={{
            height: "65px",
            width: "70px",
            marginTop: "10px",
            textAlign: "center",
          }}
          className="image-rounded text-center"
        />
      </Link>
    </div>
    <div className="navbar-menu-wrapper d-flex align-items-stretch">
      <button
        className="navbar-toggler navbar-toggler align-self-center"
        type="button"
        data-toggle="minimize"
      >
        <span className="mdi mdi-menu"></span>
      </button>
      <ul className="navbar-nav navbar-nav-right">
        <li className="nav-item nav-profile dropdown">
          <a
            className="nav-link dropdown-toggle"
            id="profileDropdown"
            href="#"
            data-bs-toggle="dropdown"
            aria-expanded="false"
          >
            <div className="nav-profile-text">
              <p className="mb-1 text-black">{localStorage.getItem("emp_name")}</p>
            </div>
          </a>
          <div className="dropdown-menu navbar-dropdown" aria-labelledby="profileDropdown">
            <a className="dropdown-item" href="#">
              <i className="mdi mdi-cached me-2 text-success"></i>
              <button
                className="dropdown-item"
                type="button"
                data-bs-toggle="modal"
                data-bs-target="#myModalChangePassword"
              >
                Change Password
              </button>
            </a>
            <div className="dropdown-divider"></div>
            <a className="dropdown-item" href="#">
              <i className="mdi mdi-logout me-2 text-primary"></i>
              <button className="dropdown-item" onClick={logout}>
                Logout
              </button>
            </a>
          </div>
        </li>
      </ul>
    </div>
  </nav>

  <div className="container-fluid page-body-wrapper">
    <nav className="sidebar sidebar-offcanvas" id="sidebar">
      <ul className="nav">
        {/* Dashboard */}
        <li
          className="nav-item mt-4"
          style={{
            backgroundColor: location.pathname === "/Dashboard" ? "#5e50f9" : "transparent",
            borderRadius: location.pathname === "/Dashboard" ? "8px" : "0",
          }}
        >
          <Link
            className="nav-link"
            to="/Dashboard"
            style={{
              color: location.pathname === "/Dashboard" ? "#fff" : "#bba8bf",
              fontWeight: location.pathname === "/Dashboard" ? "600" : "normal",
            }}
          >
            <i
              className="mdi mdi-home menu-icon me-3"
              style={{
                marginLeft: 0,
                color: location.pathname === "/Dashboard" ? "#fff" : "rgba(187, 168, 191, 0.96)",
              }}
            ></i>
            <span className="menu-title ms-3">Dashboard</span>
          </Link>
        </li>

        {/* Dynamic Menus */}
        {Object.entries(permissions).map(([category, items]) => {
          const isCategoryActive = items.some(
            (item) => location.pathname === item.routePath
          );
          return (
            <li
              className="nav-item"
              key={category}
              style={{
                backgroundColor: isCategoryActive ? "#f4f4ff" : "transparent",
                borderRadius: isCategoryActive ? "8px" : "0",
              }}
            >
              <a
                className="nav-link"
                data-bs-toggle="collapse"
                href={`#${category}`}
                aria-expanded={isCategoryActive ? "true" : "false"}
                aria-controls={category}
                style={{
                  display: "flex",
                  alignItems: "center",
                  color: isCategoryActive ? "#5e50f9" : "#bba8bf",
                  fontWeight: isCategoryActive ? "600" : "normal",
                }}
              >
                <i
                  className={`mdi ${items?.[0]?.icons || ""} me-3`}
                  style={{
                    marginLeft: 0,
                    color: isCategoryActive ? "#5e50f9" : "rgba(187, 168, 191, 0.96)",
                  }}
                ></i>
                <span className="menu-title ms-3">{category}</span>
              </a>
              <div
                className={`collapse ${isCategoryActive ? "show" : ""}`}
                id={category}
              >
                <ul className="nav flex-column sub-menu">
                  {items.map((item, index) => {
                    const isActive = location.pathname === item.routePath;
                    return (
                      <li
                        className="nav-item"
                        key={index}
                        style={{
                          backgroundColor: isActive ? "#e0dcff" : "transparent",
                          borderRadius: isActive ? "6px" : "0",
                          margin: "2px 10px",
                        }}
                      >
                        <Link
                          className="nav-link"
                          to={item.routePath}
                          style={{
                            color: isActive ? "#5e50f9" : "#6c757d",
                            fontWeight: isActive ? "600" : "normal",
                            paddingLeft: "25px",
                          }}
                        >
                          {item.name}
                        </Link>
                      </li>
                    );
                  })}
                </ul>
              </div>
            </li>
          );
        })}
      </ul>
    </nav>

    <div className="main-panel">
      <div className="content-wrapper">{children}</div>
      <footer className="footer">
        <div className="d-sm-flex justify-content-center justify-content-sm-between">
          <span className="text-muted text-center text-sm-left d-block d-sm-inline-block">
            Copyright © 2025{" "}
            <a href="https://skyjumpertrampolinepark.com/" target="_blank">
              SKYJUMPER
            </a>
            . All rights reserved.
          </span>
          <span className="float-none float-sm-right d-block mt-1 mt-sm-0 text-center">
            SKYJUMPER <i className="mdi mdi-heart text-danger"></i>
          </span>
        </div>
      </footer>
    </div>
  </div>


      <div className="modal" id="myModalChangePassword">
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-header">
              <h4 className="modal-title">Reset Password</h4>
              <button type="button" className="btn-close" data-bs-dismiss="modal"></button>
            </div>
            <div className="modal-body">
              <div className="row my-3">
                <div className="col-md-12">
                  <label className="mb-2">Old Password</label>
                  <input
                    type="text"
                    className="form-control"
                    value={currentPassword}
                    onChange={(e) => setCurrentPassword(e.target.value)}></input>
                </div>
              </div>
              <div className="row">
                <div className="col-md-12">
                  <label className="mb-2">New Password</label>
                  <input
                    type="text"
                    className="form-control"
                    value={newPassword}
                    onChange={(e) => {
                      setNewPassword(e.target.value)
                    }}></input>
                </div>
              </div>
            </div>

            <div className="modal-footer">
              <button onClick={resetPasswordData} type="button" className="btn btn-success">Change</button>
              <button type="button" className="btn btn-danger" data-bs-dismiss="modal">Close</button>
            </div>
          </div>
        </div>
      </div>

    </div>

  );
}

export default Navbar;
